import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import {
  getApprovalByType,
  hasSign,
  renderDate,
  renderTime,
  renderSign
} from './utils/PtwCommonUtils.tsx';

interface IProps {
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  const approvalList = props.itemData?.approvalMVOList;
  const closingEntrtSupervisor = getApprovalByType(approvalList, 'CLOSURE', 1);
  const closingSeAgt = getApprovalByType(approvalList, 'CLOSURE', 2);
  const closingSeaPtwCoordinator = getApprovalByType(approvalList, 'CLOSURE', 3);

  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={8} className={'preview-close-line'}>
              CLOSE
            </th>
          </tr>
          <tr>
            <th colSpan={2}>Signed Date/Time</th>
            <th colSpan={2}>ENTRY SUPERVISOR</th>
            <th colSpan={2}>SE&A AGT</th>
            <th colSpan={2}>SE&A PTW Coordinator</th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>DATE</th>
            <th>SIGN</th>
            <th>DATE</th>
            <th>SIGN</th>
            <th>DATE</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td className={'saf-td-center'}>
              &nbsp;{hasSign(closingSeaPtwCoordinator) ? renderDate(closingSeaPtwCoordinator) : ''}
              &nbsp;
            </td>
            <td className={'saf-td-center'}>
              {hasSign(closingEntrtSupervisor) ? renderTime(closingSeaPtwCoordinator) : ''}
            </td>
            <td className={'saf-td-center'}>
              {hasSign(closingEntrtSupervisor) ? renderDate(closingEntrtSupervisor) : ''}
            </td>
            <td className={'saf-td-center'}>{renderSign(closingEntrtSupervisor)}</td>
            <td className={'saf-td-center'}>
              {hasSign(closingSeAgt) ? renderDate(closingSeAgt) : ''}
            </td>
            <td className={'saf-td-center'}>{renderSign(closingSeAgt)}</td>
            <td className={'saf-td-center'}>
              {hasSign(closingSeaPtwCoordinator) ? renderDate(closingSeaPtwCoordinator) : ''}
            </td>
            <td className={'saf-td-center'}>{renderSign(closingSeaPtwCoordinator)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
